<template>
  <div class="mx-4 text-center">
    <img :src="url" class="inline" loading="lazy" />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  url: {
    type: String,
    default: 'https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_300,w_300,f_auto,q_auto/2416901/537748_316211.png',
  },
})

const url = computed(() => props.url)
</script>

<style scoped>
img {
  max-width: 180px;
  max-height: 100px;
}
</style>
